import { RegisterImplementationProps } from 'constants/types';
import SignInBase from '../SignInBase';
import InstructionsCheckbox from 'components/Input/InstructionsCheckboxInput';
import MainContainer from '../SignInMainContainer';
import LoaderButton from 'components/Button/LoaderButton';
import Input from 'components/Input/Input';
import { getProviderFormLabel } from '../utils';

const SignInProxusHrApi = ({
  provider,
  isLoading,
  onSubmit,
  instructionsLink,
}: RegisterImplementationProps) => {
  const instructions = (
    <>
      <p>
        To connect your {provider.displayName} account, please follow the
        instructions linked below to retrieve your API key and secret. Once you
        have them, return to this page and enter the information to continue.
      </p>
    </>
  );

  return (
    <SignInBase
      formLabel={getProviderFormLabel(provider)}
      instructions={instructions}
      instructionsLink={instructionsLink}
      divider
      onSubmit={onSubmit}
      fieldNames={['instructionCheck', 'username', 'password', 'clientCode']}
      render={({ instructionCheck, username, password, clientCode }) => {
        return (
          <>
            <MainContainer useNewDesign>
              <InstructionsCheckbox
                checked={instructionCheck.value}
                onChange={(checked) => instructionCheck.onChange(checked)}
              />
              <Input
                value={username.value}
                onChange={(event) => username.onChange(event.target.value)}
                invalid={username.invalid}
                label="API Key"
                id="username"
              />
              <Input
                value={password.value}
                onChange={(event) => password.onChange(event.target.value)}
                invalid={password.invalid}
                label="API Secret"
                id="password"
              />
              <Input
                value={clientCode.value}
                onChange={(event) => clientCode.onChange(event.target.value)}
                invalid={clientCode.invalid}
                label="Client ID"
                id="clientCode"
              />
            </MainContainer>
            <LoaderButton
              text="Connect"
              isLoading={isLoading}
              disabled={isLoading || !instructionCheck.value || !username.value}
              type="submit"
            />
          </>
        );
      }}
    />
  );
};

export default SignInProxusHrApi;
